import { render, staticRenderFns } from "./s1_index.vue?vue&type=template&id=360fa5ef&scoped=true&"
import script from "./s1_index.vue?vue&type=script&lang=js&"
export * from "./s1_index.vue?vue&type=script&lang=js&"
import style0 from "./s1_index.vue?vue&type=style&index=0&id=360fa5ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360fa5ef",
  null
  
)

export default component.exports